import React from 'react';
import clone from 'clone';
class CategoryLoadMore extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
      return (
        <div className="rq-loadmore-button"><a href={this.props.viewMoreLink} className="load-more-link">{API.LANG.LOAD_MORE_BUTTON}</a></div>
     );
    return (<div></div>);
  }
}

CategoryLoadMore.propTypes = {
  'onClick': React.PropTypes.func,
  'show': React.PropTypes.node,
};

export default CategoryLoadMore;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/block/bar/categoryLoadMore.js
 **/